import React from 'react';

import type { AvailableExperiments, TFunction, TextDirection } from './../../ricos-types/index.js';

export const GlobalContext = React.createContext<{
  experiments: AvailableExperiments;
  isMobile: boolean;
  t?: TFunction;
  languageDir?: TextDirection;
}>({
  isMobile: false,
  experiments: {},
  languageDir: 'ltr',
});
